var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "form",
    {
      on: {
        submit: function ($event) {
          $event.preventDefault()
          return _vm.submit.apply(null, arguments)
        },
      },
    },
    [
      _c("div", { staticClass: "modal-card" }, [
        _c("header", { staticClass: "modal-card-head" }, [
          _c("p", { staticClass: "modal-card-title" }, [
            _vm._v(" " + _vm._s(_vm.schedule.name) + " "),
            _vm.schedules.length > 1
              ? _c("span", [_vm._v(" + " + _vm._s(_vm.schedules.length - 1))])
              : _vm._e(),
          ]),
        ]),
        _c(
          "section",
          { staticClass: "modal-card-body" },
          [
            _c(
              "b-field",
              {
                attrs: {
                  label: _vm.$t("pages.closure_schedule.mail_1_column_title"),
                },
              },
              [
                _c("b-datepicker", {
                  attrs: {
                    name: "mail1date",
                    locale: "en-CA",
                    icon: "calendar-alt",
                    placeholder: "Mail 1 Date",
                  },
                  model: {
                    value: _vm.returnUser.mail1,
                    callback: function ($$v) {
                      _vm.$set(_vm.returnUser, "mail1", $$v)
                    },
                    expression: "returnUser.mail1",
                  },
                }),
                _c(
                  "b-button",
                  {
                    staticClass: "is-small",
                    attrs: { type: "is-warning" },
                    on: {
                      click: () => {
                        _vm.returnUser.mail1 = null
                      },
                    },
                  },
                  [_vm._v(" No Date ")]
                ),
              ],
              1
            ),
            _c(
              "b-field",
              {
                attrs: {
                  label: _vm.$t("pages.closure_schedule.mail_2_column_title"),
                },
              },
              [
                _c("b-datepicker", {
                  attrs: {
                    name: "mail2date",
                    locale: "en-CA",
                    icon: "calendar-alt",
                    placeholder: "Mail 2 Date",
                  },
                  model: {
                    value: _vm.returnUser.mail2,
                    callback: function ($$v) {
                      _vm.$set(_vm.returnUser, "mail2", $$v)
                    },
                    expression: "returnUser.mail2",
                  },
                }),
                _c(
                  "b-button",
                  {
                    staticClass: "is-small",
                    attrs: { type: "is-warning" },
                    on: {
                      click: () => {
                        _vm.returnUser.mail2 = null
                      },
                    },
                  },
                  [_vm._v(" No Date ")]
                ),
              ],
              1
            ),
            _c(
              "b-field",
              {
                attrs: {
                  label: _vm.$t("pages.closure_schedule.mail_template_picker"),
                },
              },
              [
                _c(
                  "b-select",
                  {
                    attrs: {
                      placeholder: _vm.$t(
                        "pages.closure_schedule.mail_template_picker_placeholder"
                      ),
                    },
                    model: {
                      value: _vm.returnUser.template,
                      callback: function ($$v) {
                        _vm.$set(_vm.returnUser, "template", $$v)
                      },
                      expression: "returnUser.template",
                    },
                  },
                  _vm._l(_vm.templates, function (grp) {
                    return _c(
                      "option",
                      { key: grp.id, domProps: { value: grp.id } },
                      [_vm._v(" " + _vm._s(grp.templateName) + " ")]
                    )
                  }),
                  0
                ),
              ],
              1
            ),
          ],
          1
        ),
        _c("footer", { staticClass: "modal-card-foot" }, [
          _c(
            "button",
            {
              staticClass: "button is-info is-fullwidth",
              attrs: { type: "submit" },
            },
            [_vm._v(" " + _vm._s(_vm.$t("global.submit")) + " ")]
          ),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }